/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Restored1Inputs */

const vi_cmstools_restored1 = /** @type {(inputs: Cmstools_Restored1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nạp bản cũ vào bản đang soạn. Kiểm tra rồi bấm Đăng để lên web.`)
};

/**

* @param {Cmstools_Restored1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_restored1 = /** @type {((inputs?: Cmstools_Restored1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Restored1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_restored1(inputs)
});
export { cmstools_restored1 as "cmsTools_restored" }